import { useEffect, useState } from 'react';
import './Heading.css';

const names = ['Bryneth Palthrow', 'Bryn Diesel', 'Bryn Van Bike', 'Osama Bryn Laden', 'Bryn-stagram', 'Bryn Dog', 'Bryn-da-lin', 'Brian'];

export const Heading = () => {
  const [currentNickId, setCurrentNickId] = useState(0);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (currentNickId === names.length - 1) {
        setCurrentNickId(0);
      } else {
        setCurrentNickId(currentNickId + 1);
      }
    }, 3000);

    return () => clearInterval(timeout)
  });

  return (
    <div className='heading-container'>
      <div className='heading-name'>BRYN</div>
      <div className='heading-nick'>{`"${names[currentNickId]}"`}</div>
      <div className='heading-name'>CURRAN</div>
    </div>
  )
}
